import React, {useEffect} from "react";
import "../PageCss/AboutUs.css"
import Description from "../components/Description";
import { useAappContext } from "../context/AppContext";

const AboutUs = () =>{
const {getDevHistory,devHistory:Devhistory,getApiHost,ApiHost, getApiData,apiData}= useAappContext();
let vid;
useEffect(()=>{
    getDevHistory()
    getApiHost()
    getApiData('/avasisbd/')
}, [1])


    return  (
        <>
        <section id="video-description" className="section-p1 section-m1">
            <div className="vide-title">
                <h2 className="title">Video Title</h2>
            </div>
    {   
    apiData.map((vdata)=>{
        {vdata.youtubeVideoId ?  vid=vdata.youtubeVideoId  :  vid='JxxZwE5I9IA' }
        return(
            <>
            <iframe width="100%" style={{borderRadius:5}} height="450px" src={"https://www.youtube.com/embed/"+vid} title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy ="strict-origin-when-cross-origin" allowFullScreen ></iframe>
            </>
        )
    })
        // <iframe width="90%" height="550px" src="https://www.youtube.com/embed/JxxZwE5I9IA?" title="YouTube video player" frameBorder='0'  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy ="strict-origin-when-cross-origin" allowFullScreen ></iframe>
    }
            

        </section>

        <Description />

    <section id="description" className="section-p1 section-m1">
        <div className="descripton-1">
            <h1><u>History and Development</u></h1>
                
                    {
                    Devhistory.map((devhistory, index)=>{
                        const {id:itemid,year,description,option1,option2,option3}=devhistory;
                        return (
                        <div key={itemid}>
                            <p key={index}>
                                <span>{year + ' :'}</span> {description} <br/>
                                <ul id="HandDeveList">
                                {option1 ? <li key={index} className="ulist" >{option1}</li> : ''}
                                {option2 ? <li key={index} className="ulist" >{option2}</li> : ''}
                                {option3 ? <li key={index} className="ulist" >{option3}</li> : ''}
                                </ul> 
                            </p>
                        </div>
                        )
                        
                    })
                }
        </div>
        <div className="images">
        {
        Devhistory.map((devhistory ,index)=>{
            const {id:imgeid,image}=devhistory;
                return (
                <>
                {image ? <img key={imgeid} src={ApiHost+image} alt="img"/> : ''}
                </>
                )
        })
        }
     </div>
    </section>



        </>
    );
}

export default AboutUs;